// keyCombinationsMap.ts
import { QueryParams } from "@router/route-params";
/**
 *  "Alt+KeyA" - combination to enable the alpha feature flag
 *  "Alt+KeyB" - combination to enable the beta feature flag
 *  "Alt+KeyD" - combination to enable the dev feature flag
 *  "Alt+KeyN" - combination to disable all the feature flag
 */
export const keyCombinationsMap = new Map([["Alt+KeyA", {
  hasAltKey: true,
  shouldSkipProd: false,
  isOnlyForInternalUsersInProd: true,
  action: setQueryParam => setQueryParam(QueryParams.enableAlpha, "true")
}], ["Alt+KeyB", {
  hasAltKey: true,
  shouldSkipProd: false,
  isOnlyForInternalUsersInProd: true,
  action: setQueryParam => setQueryParam(QueryParams.enableBeta, "true")
}], ["Alt+KeyD", {
  hasAltKey: true,
  shouldSkipProd: false,
  isOnlyForInternalUsersInProd: true,
  action: setQueryParam => setQueryParam(QueryParams.enableDev, "true")
}], ["Alt+KeyN", {
  hasAltKey: true,
  shouldSkipProd: false,
  action: setQueryParam => {
    const search = window.location.search ?? "";

    // Only set params to false if they are included in the URL
    // This way it is harder for users to accidentally find them
    if (search.includes(QueryParams.enableAlpha)) {
      setQueryParam(QueryParams.enableAlpha, "false");
    }
    if (search.includes(QueryParams.enableBeta)) {
      setQueryParam(QueryParams.enableBeta, "false");
    }
    if (search.includes(QueryParams.enableDev)) {
      setQueryParam(QueryParams.enableDev, "false");
    }
  }
}]]);